import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcRequirementReviewMethod } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcRequirementReviewMethodList,

    LoadCcRequirementReviewMethods,
    SortCcRequirementReviewMethods,
    DeleteCcRequirementReviewMethod,

    setCcRequirementReviewMethodList,
    setCcRequirementReviewMethodIds,
    setCcRequirementReviewMethodSort,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    SortRows,
    DeleteRow,
} from "client/components"

import Columns from "./columns"
import Edit from "./edit"

const ReviewMethod = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const methodList = useSelector((state: StoreType) => state.ccRequirementReviewMethod.methodList)
    const methodIds = useSelector((state: StoreType) => state.ccRequirementReviewMethod.methodIds)
    const sortColumn = useSelector((state: StoreType) => state.ccRequirementReviewMethod.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.ccRequirementReviewMethod.sortOrder)
    const filters = useSelector((state: StoreType) => state.ccRequirementReviewMethod.filters)
    const reloadList = useSelector((state: StoreType) => state.ccRequirementReviewMethod.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultRequirementsReviewMethodAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadCcRequirementReviewMethods(userData.accountId, project.id).then((res) => {
            dispatch(setCcRequirementReviewMethodList(res))
            setLoadState(IDLE)
        })
    }, [reloadList, project, defaultRequirementsReviewMethodAssigned])

    useEffect(() => {
        const sortedIds = SortCcRequirementReviewMethods(Object.values(methodList), sortColumn, sortOrder, filters)
        dispatch(setCcRequirementReviewMethodIds(sortedIds))
    }, [methodList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof CcRequirementReviewMethod, order) => {
        dispatch(setCcRequirementReviewMethodSort(column, order))
    }

    const onDelete: DeleteRow = (method: CcRequirementReviewMethod, callback) => {
        DeleteCcRequirementReviewMethod(method.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const methodListCopy: CcRequirementReviewMethodList = methodList ? deepCopy(methodList) : {}
                delete methodListCopy[method.id]
                dispatch(setCcRequirementReviewMethodList(methodListCopy))
                dispatch(setCcRequirementReviewMethodIds(methodIds.filter((id) => id !== method.id)))
            })
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={methodList}
                dataIds={methodIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="sm"
                showPagination
                onSort={onSort}
                onDelete={onDelete}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addReviewMethod",
                            content: <Edit methodId={0} editAccess={editAccess} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default ReviewMethod
